import { dataEnvelopeOpenSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEnvelopeOpenSolid = /*#__PURE__*/createIcon(dataEnvelopeOpenSolid)
export default IconEnvelopeOpenSolid
